import { createContext } from 'react';
import { QueryJob } from 'src/queries/Job';
import { Customization } from 'src/queries/Company/customizations';
import { Employee, Company, Insured, Item, Room, SnapshotImage, Video } from 'src/types';

export type TextMessageContextType = {
  job: QueryJob;
  rooms: Room[];
  videos: Video[];
  images: SnapshotImage[];
  items: Item[];
  jobCompany: Company;
  insured: Insured;
  customizations: Customization[];
  employee: Employee | undefined;
};

export const TextMessageContext = createContext<TextMessageContextType>({} as TextMessageContextType);
